import { render, staticRenderFns } from "./Evaluation.vue?vue&type=template&id=073b86aa&scoped=true&"
var script = {}
import style0 from "./Evaluation.vue?vue&type=style&index=0&id=073b86aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073b86aa",
  null
  
)

export default component.exports